'use strict';

module.exports = {
	AffiliateTeamIdentityProvider: require('../../models/affiliate-team-identity-provider'),
	AuthenticationModel: require('../../models/authentication-model'),
	OneTimePasswordAuthenticator: require('../../models/one-time-password-authenticator'),
	OAuthApi: require('../../models/oauth-api'),
	MicrosoftAuthShim: require('../../models/microsoft-auth-shim'),
	MicrosoftAuthenticator: require('../../models/microsoft-authenticator'),
	GoogleAuthenticator: require('../../models/google-authenticator'),
	GoogleShim: require('../../models/google-shim'),
	Poller: require('../../models/poller'),
	TaskRetrier: require('../../models/task-retrier'),
	Reauthenticator: require('../../models/reauthenticator'),
	SubscriptionModel: require('../../models/subscription-model'),
	MicrosoftTeamsIdentityProvider: require('../../models/microsoft-teams-identity-provider')
};
